var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 44.0747 44",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1009_297",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1009_297)",
    transform: "matrix(0.9999999999999999, 0, 0, 0.9999999999999999, 0, -8.881784197001252e-16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0373 44C34.2082 44 44.0747 34.1503 44.0747 22C44.0747 9.84974 34.2082 0 22.0373 0C9.86645 0 0 9.84974 0 22C0 34.1503 9.86645 44 22.0373 44Z",
    fill: "#524EFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2534 15.348L13.0663 14.3621C11.5698 16.1348 10.5922 18.3458 10.3428 20.7758L11.8791 20.9153C12.0986 18.8039 12.9565 16.8818 14.2634 15.348H14.2534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.46 20.9153L33.9963 20.7758C33.7469 18.3458 32.7593 16.1248 31.2628 14.3621L30.0757 15.348C31.3826 16.8917 32.2405 18.8138 32.47 20.9252L32.46 20.9153Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.699 13.984L29.6866 12.7989C27.9009 11.3448 25.6862 10.3987 23.252 10.1796L23.1123 11.7133C25.2272 11.9025 27.1526 12.7291 28.699 13.994V13.984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1966 11.7133L21.057 10.1796C18.6328 10.4086 16.4181 11.3548 14.6323 12.8088L15.62 13.994C17.1663 12.7291 19.0917 11.9025 21.1966 11.7133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.3425 21.146C14.5121 19.5426 15.1705 18.0885 16.1581 16.9233L14.971 15.9373C13.7938 17.3316 13.0057 19.0844 12.8062 20.9966L14.3425 21.136V21.146Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1964 15.9063C18.3736 14.9502 19.8301 14.3228 21.4263 14.1834L21.2866 12.6497C19.3712 12.8289 17.6254 13.5759 16.2188 14.7212L17.2064 15.9063H17.1964Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1597 16.9133C29.1573 18.0786 29.8157 19.5326 29.9853 21.146L31.5216 21.0066C31.3221 19.0844 30.534 17.3316 29.3468 15.9373L28.1597 16.9233V16.9133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8726 14.1834C24.4687 14.3228 25.9352 14.9502 27.1124 15.8964L28.1001 14.7112C26.6934 13.5659 24.9376 12.819 23.0222 12.6497L22.8825 14.1834H22.8726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2441 18.4961C26.9325 19.2928 27.3814 20.2788 27.5111 21.3743L29.0474 21.2349C28.8878 19.8207 28.3092 18.5359 27.4313 17.5201L26.2441 18.506V18.4961Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6431 16.6535C23.7305 16.7531 24.7181 17.1714 25.5262 17.8087L26.5138 16.6236C25.4763 15.787 24.1894 15.2393 22.7927 15.1198L22.653 16.6535H22.6431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7821 17.8187C19.5802 17.1714 20.5778 16.7531 21.6552 16.6535L21.5155 15.1198C20.1189 15.2492 18.832 15.797 17.7944 16.6336L18.7821 17.8187Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8166 21.3743C16.9463 20.2788 17.3952 19.2928 18.0736 18.506L16.8864 17.5201C16.0185 18.5459 15.4399 19.8207 15.2803 21.2249L16.8166 21.3644V21.3743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4906 29.8979L14.5029 31.0831C16.2986 32.5969 18.5532 33.5829 21.0174 33.8119L21.157 32.2782C19.0022 32.0691 17.0468 31.2126 15.4806 29.8979H15.4906Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1953 28.5234L31.3825 29.5094C32.8589 27.7067 33.8167 25.4559 34.0162 22.996L32.4799 22.8566C32.3103 24.9978 31.4822 26.9598 30.1953 28.5333V28.5234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1316 32.2882L23.2712 33.8219C25.7453 33.5929 27.9999 32.6069 29.7956 31.1031L28.808 29.9179C27.2417 31.2325 25.2764 32.089 23.1216 32.2882H23.1316Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8488 22.8491L10.3125 22.9885C10.512 25.4484 11.4697 27.6893 12.9362 29.4919L14.1234 28.5059C12.8464 26.9324 12.0184 24.9804 11.8488 22.8391V22.8491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4057 29.8187C19.7596 29.6593 18.2732 29.002 17.076 27.9962L16.0884 29.1813C17.515 30.3764 19.3007 31.1632 21.256 31.3524L21.3957 29.8187H21.4057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.0057 22.6198C29.876 24.2531 29.2574 25.747 28.2798 26.9521L29.4669 27.9381C30.6342 26.5039 31.3824 24.7212 31.542 22.7692L30.0057 22.6298V22.6198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2317 28.0062C26.0346 29.012 24.5382 29.6694 22.8921 29.8187L23.0318 31.3525C24.9971 31.1732 26.7828 30.3864 28.2094 29.1913L27.2217 28.0062H27.2317Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0388 26.9321C15.0712 25.727 14.4427 24.2431 14.3229 22.6098L12.7866 22.7492C12.9462 24.6913 13.6945 26.474 14.8517 27.9081L16.0388 26.9222V26.9321Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5315 22.3805C27.4517 23.5059 27.0327 24.5317 26.3643 25.3583L27.5514 26.3443C28.4094 25.2886 28.9581 23.964 29.0678 22.5299L27.5315 22.3905V22.3805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.6562 26.0944C24.8382 26.7915 23.8106 27.2496 22.6733 27.3492L22.813 28.883C24.2595 28.7435 25.5864 28.1659 26.6339 27.2795L25.6462 26.0944H25.6562Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.9548 25.3484C17.2964 24.5217 16.8774 23.4959 16.7976 22.3805L15.2612 22.5199C15.371 23.9541 15.9197 25.2687 16.7676 26.3244L17.9548 25.3384V25.3484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6353 27.3492C20.508 27.2397 19.4805 26.7816 18.6624 26.0844L17.6748 27.2696C18.7223 28.1559 20.0392 28.7435 21.4857 28.883L21.6254 27.3492H21.6353Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.36305acca64158b0d426fe0c3d79f540.svg";
export { ForwardRef as ReactComponent };